import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const errorLogFeatureKey = 'errorLog'

export interface HeliosError {
  id: string //UUID
  timestamp: Date
  message: string
  type: 'http' | 'session-load' | 'websocket'
  sessionId?: string | null
  error: string
}

export interface HeliosHttpError extends HeliosError {
  type: 'http'
  url: string
  method: string
  responseCode: number
  requestPayload?: string
}

export interface HeliosWebsocketError extends HeliosError {
  type: 'websocket'
  subType: string
}

export interface HeliosSessionLoadError extends HeliosError {
  type: 'session-load'
  service: string
  status: string
}

export type ErrorLogRedux = {
  errors: HeliosError[]
}

export const errorLogInitialState: ErrorLogRedux = {
  errors: [],
}

export const errorLogSlice = createSlice({
  name: errorLogFeatureKey,
  initialState: errorLogInitialState,
  reducers: {
    reportError: (oldState, action: PayloadAction<HeliosError>) => ({
      errors: [
        {
          ...action.payload,
        },
        ...oldState.errors,
      ],
    }),
    clearErrors: oldState => ({
      ...oldState,
      errors: [],
    }),
    removeError: (oldState, action: PayloadAction<string>) => ({
      ...oldState,
      errors: oldState.errors.filter(err => err.id !== action.payload),
    }),
  },
})

export const { reportError, clearErrors, removeError } = errorLogSlice.actions

export default errorLogSlice.reducer
